import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FadeIn, StaggerContainer, StaggerItem } from '../components/Animations';
import { McIcon } from '../components/CraftingGrid';
import './WikiItemDetail.css';
import api from '../API/Api';

const VIDEO = "https://pub-332780ae20b540038a9ea772f1bf747c.r2.dev/background_vids/vid_1.mp4";

export default function WikiMeteors() {
  const navigate = useNavigate();
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api('getwikiseason').then(res => {
      if (res.isSuccess) setConfig(res.data.config);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <div className="wiki-detail-root" style={{ paddingTop: "8rem", textAlign: "center", color: "var(--text-muted)" }}>
        Loading…
      </div>
    );
  }

  const STATUS_COLORS = { active: "#1aaf12", upcoming: "#c8b800", disabled: "#7a7a7a" };
  const STATUS_LABELS = { active: "Active", upcoming: "Upcoming", disabled: "Disabled" };

  const meteorStatus = config?.meteor_status ?? "upcoming";
  const meteorStatusColor = STATUS_COLORS[meteorStatus] ?? "#c8b800";
  const meteorStatusLabel = STATUS_LABELS[meteorStatus] ?? "Upcoming";

  return (
    <div className="wiki-detail-root">
      <div className="wiki-detail-hero">
        <video className="wiki-detail-hero-vid" src={VIDEO} autoPlay muted loop playsInline />
        <div className="wiki-detail-hero-overlay" />
        <FadeIn className="wiki-detail-hero-content container" y={30} duration={0.8}>
          <button className="wiki-back-btn" onClick={() => navigate(-1)}>← Back</button>
          <div className="wiki-detail-title-section">
            <div className="wiki-detail-icon-box wmd-icon-box" style={{ '--tier-color': '#e8642c' }}>
              <McIcon materialKey="fire_charge" size={56} />
            </div>
            <div>
              <h1 className="wiki-detail-item-name" style={{ color: "#e8642c" }}>
                Meteor Events
              </h1>
              <div className="wiki-detail-item-type" style={{ color: "#e8642c" }}>
                Season {config?.season_number ?? 1} · {meteorStatusLabel} Event
              </div>
            </div>
          </div>
        </FadeIn>
      </div>

      <StaggerContainer className="container">
        <div className="wiki-detail-grid">

          {/* ── Main ── */}
          <StaggerItem className="wiki-detail-main">

            <div>
              <span className="wiki-detail-label">Overview</span>
              <div style={{
                background: "rgba(232,100,44,0.06)", border: "1px solid rgba(232,100,44,0.3)",
                borderRadius: "0.75rem", padding: "1.25rem",
                display: "flex", flexDirection: "column", gap: "0.85rem",
              }}>
                <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", flexWrap: "wrap" }}>
                  <div style={{
                    display: "flex", alignItems: "center", gap: "0.5rem",
                    background: `${meteorStatusColor}20`, border: `1px solid ${meteorStatusColor}`,
                    borderRadius: "2rem", padding: "0.3rem 0.85rem",
                  }}>
                    <span style={{ width: 7, height: 7, borderRadius: "50%", background: meteorStatusColor, boxShadow: `0 0 5px ${meteorStatusColor}`, display: "inline-block" }} />
                    <span style={{ color: meteorStatusColor, fontWeight: 700, fontSize: "0.8rem", textTransform: "uppercase", letterSpacing: "0.08em" }}>
                      {meteorStatusLabel}
                    </span>
                  </div>
                  {config?.meteor_schedule && (
                    <span style={{ color: "var(--text-muted)", fontSize: "0.78rem", display: "flex", alignItems: "center", gap: "0.35rem" }}>
                      <McIcon materialKey="clock" size={13} /> {config.meteor_schedule}
                    </span>
                  )}
                </div>

                <p style={{ margin: 0, color: "var(--text-secondary)", lineHeight: 1.65, fontSize: "0.88rem" }}>
                  {config?.meteor_description || "Meteors tear through the sky and crash into the world at scheduled times. Each impact leaves a crater packed with rare loot — but everyone on the server sees where it lands."}
                </p>

                <div style={{ display: "flex", flexWrap: "wrap", gap: "0.4rem", paddingTop: "0.2rem" }}>
                  {["Visible server-wide", "Crater loot", "Contested drops"].map(tag => (
                    <span key={tag} style={{
                      display: "flex", alignItems: "center", gap: "0.35rem",
                      background: "rgba(232,100,44,0.08)", border: "1px solid rgba(232,100,44,0.27)",
                      borderRadius: "2rem", padding: "0.18rem 0.6rem",
                      fontSize: "0.75rem", color: "#e8642c", fontWeight: 600,
                    }}>
                      <span style={{ width: 5, height: 5, borderRadius: "50%", background: "#e8642c", flexShrink: 0 }} />
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>

          </StaggerItem>

          {/* ── Sidebar ── */}
          <StaggerItem className="wiki-detail-sidebar">

            <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
              <Link to="/wiki/supply-drops" style={{ color: "var(--teal)", textDecoration: "none", fontSize: "0.9rem" }}>→ Supply Drops</Link>
              <Link to="/wiki/roots"    style={{ color: "var(--teal)", textDecoration: "none", fontSize: "0.9rem" }}>→ Explore the Roots</Link>
              <Link to="/wiki/season"   style={{ color: "var(--teal)", textDecoration: "none", fontSize: "0.9rem" }}>→ Season Info</Link>
              <Link to="/wiki/items"    style={{ color: "var(--teal)", textDecoration: "none", fontSize: "0.9rem" }}>→ Browse All Items</Link>
              <Link to="/wiki/updates"  style={{ color: "var(--teal)", textDecoration: "none", fontSize: "0.9rem" }}>→ View Updates</Link>
            </div>

          </StaggerItem>
        </div>
      </StaggerContainer>
    </div>
  );
}
